import { useRef } from "react";
import { IoMdClose } from "react-icons/io";
import "./modal.scss";
import Button from "../button/button";

export default function Modal({
    title,
    isOpen,
    onClose,
    children,
    onCancel,
    onAccept,
    outlineButtonLabel = "Cancelar",
    primaryButtonLabel = "Aceptar",
    className, // acepta clase opcional para modificar estilo sólo en usos concretos
    hideFooter = false, // nuevo prop
}) {
    const modalRef = useRef(null);

    const handleOutsideClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className={`modal ${className || ""}`} onClick={handleOutsideClick}>
            <div className="modal__container" ref={modalRef} role="dialog" aria-modal="true">
                <div className="modal__header">
                    <h2 className="modal__header__title">{title}</h2>
                    <button
                        className="modal__header__btn-close"
                        onClick={onClose}
                    >
                        <IoMdClose />
                    </button>
                </div>

                <div className="modal__content">{children}</div>

                {!hideFooter && (
                    <div className="modal__footer">
                        <Button
                            label={outlineButtonLabel}
                            variant="outline"
                            fullWidth={true}
                            onClick={onCancel || onClose}
                        />
                        {onAccept && (
                            <Button
                                label={primaryButtonLabel}
                                variant="filled"
                                fullWidth={true}
                                onClick={onAccept}
                            />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
